import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL;

// === PLATZHALTER ===
// Ruft eine paginierte und gefilterte Liste von Platzhaltern ab
const getAllPlaceholders = (params) => {
    return axios.get(API_URL + "platzhalter", { headers: authHeader(), params });
};

// NEU: Ruft die Liste der verfügbaren Kategorien ab
const getPlaceholderCategories = () => {
    return axios.get(API_URL + "platzhalter/categories", { headers: authHeader() });
};

// === VEREINBARUNGSTITEL ===
// Ruft alle Vereinbarungstitel ab
const getAllAgreementTitles = () => {
    return axios.get(API_URL + "vereinbarungstitel", { headers: authHeader() });
};

// Ruft einen einzelnen Vereinbarungstitel ab
const getAgreementTitleById = (id) => {
    return axios.get(API_URL + `vereinbarungstitel/${id}`, { headers: authHeader() });
};

// Erstellt einen neuen Vereinbarungstitel
const createAgreementTitle = (data) => {
    return axios.post(API_URL + "vereinbarungstitel", data, { headers: authHeader() });
};

// Aktualisiert einen bestehenden Vereinbarungstitel
const updateAgreementTitle = (id, data) => {
    return axios.put(API_URL + `vereinbarungstitel/${id}`, data, { headers: authHeader() });
};

// Löscht einen Vereinbarungstitel
const deleteAgreementTitle = (id) => {
    return axios.delete(API_URL + `vereinbarungstitel/${id}`, { headers: authHeader() });
};

// === TITEL-KATALOG (Aufgabe 2) ===
// Ruft die Titel-Katalog-Eintraege ab. scope='system' liefert die zentralen
// System-Titel, scope='stage' (Default) die eigenen Stufen-Titel.
const getTitleCatalog = (scope = 'stage') => {
    return axios.get(API_URL + "titel-katalog", { headers: authHeader(), params: { scope } });
};

// Legt einen neuen Katalog-Titel an.
const createTitleCatalogEntry = (data) => {
    return axios.post(API_URL + "titel-katalog", data, { headers: authHeader() });
};

// Aktualisiert einen Katalog-Titel.
const updateTitleCatalogEntry = (id, data) => {
    return axios.put(API_URL + `titel-katalog/${id}`, data, { headers: authHeader() });
};

// Loescht einen Katalog-Titel.
const deleteTitleCatalogEntry = (id) => {
    return axios.delete(API_URL + `titel-katalog/${id}`, { headers: authHeader() });
};

// === VEREINBARUNGEN ===
// Ruft alle Vereinbarungen für den aktuellen Benutzer ab
const getAllAgreements = () => {
    return axios.get(API_URL + "vereinbarungen", { headers: authHeader() });
};

// Ruft eine einzelne Vereinbarung ab (mit ersetzten Platzhaltern)
const getAgreementById = (id) => {
    return axios.get(API_URL + `vereinbarungen/${id}`, { headers: authHeader() });
};

// Erstellt eine brandneue Vereinbarung (Version 1)
const createAgreement = (data) => {
    return axios.post(API_URL + "vereinbarungen", data, { headers: authHeader() });
};

// Aktualisiert eine bestehende Vereinbarung
const updateAgreement = (id, data) => {
    return axios.put(API_URL + `vereinbarungen/${id}`, data, { headers: authHeader() });
};

// Erstellt eine neue Version einer bestehenden Vereinbarung
const createAgreementVersion = (id, data) => {
    return axios.post(API_URL + `vereinbarungen/${id}/version`, data, { headers: authHeader() });
};

// Löst den PDF-Download aus
const downloadAgreementPdf = (id) => {
    return axios.get(API_URL + `vereinbarungen/${id}/pdf`, {
        headers: authHeader(),
        responseType: 'blob', // Wichtig, damit der Browser die Antwort als Datei behandelt
    });
};

// Ruft alle Benutzer mit einer bestimmten Rolle ab
const getUsersByRole = (roleName) => {
    // Hinweis: Der URL-Pfad muss exakt dem in users.routes.js entsprechen
    return axios.get(API_URL + `users/by-role/${roleName}`, { headers: authHeader() });
};

// Löst die Synchronisierung der Platzhalter im Backend aus
const synchronizePlaceholders = () => {
    return axios.post(API_URL + "platzhalter/synchronize", {}, { headers: authHeader() });
};

// Ruft die Versionshistorie ab
const getAgreementHistory = (id) => {
    return axios.get(API_URL + `vereinbarungen/${id}/history`, { headers: authHeader() });
};

// Ruft das Aktionsprotokoll ab
const getAgreementLog = (id) => {
    return axios.get(API_URL + `vereinbarungen/${id}/log`, { headers: authHeader() });
};

// Löscht eine Vereinbarung anhand der ID
const deleteAgreement = (id) => {
    return axios.delete(API_URL + `vereinbarungen/${id}`, { headers: authHeader() });
};

const VereinbarungService = {
    getAllPlaceholders,
    getPlaceholderCategories, // <-- HIER HINZUFÜGEN
    getAllAgreementTitles,
    getAgreementTitleById,
    createAgreementTitle,
    getTitleCatalog,
    createTitleCatalogEntry,
    updateTitleCatalogEntry,
    deleteTitleCatalogEntry,
    getAllAgreements,
    getAgreementById,
    createAgreement,
    updateAgreement,
    createAgreementVersion,
    downloadAgreementPdf,
    getUsersByRole, // <-- DIESE ZEILE HINZUFÜGEN
    updateAgreementTitle, // NEU
    deleteAgreementTitle, // NEU
    synchronizePlaceholders, // NEU
    getAgreementHistory, // NEU
    getAgreementLog,     // NEU
    deleteAgreement, // NEU
};

export default VereinbarungService;